import React, { Component } from 'react';
import { EditorState, Modifier } from 'draft-js';
import { toggleCustomInlineStyle } from './draftjs-utils';


interface FontVariantProps {
    onChange: (editorState: EditorState) => void;
    editorState: EditorState;
  }

class FontVariant extends Component<FontVariantProps> {

  toggleFontVariant = (fontVariant: string) => {
    const { editorState, onChange } = this.props;
    const newState = toggleCustomInlineStyle(editorState, 'fontVariant', fontVariant);
    if (newState) {
      let contentState = null;
      if (fontVariant == "small-caps") {
        contentState = Modifier.applyInlineStyle(
          newState.getCurrentContent(),
          newState.getSelection(),
          "SMALLCAPS"
        )
      } else {
        contentState = Modifier.removeInlineStyle(
          newState.getCurrentContent(),
          newState.getSelection(),
          "SMALLCAPS"
        )
      }
      let newNewState = EditorState.push(editorState, contentState, 'insert-characters')
      if (newNewState) {
        onChange(newNewState);
      }
    }
  };

  

  public render() {

    return (
      <div className="rdw-inline-wrapper">
        <div 
          className="rdw-option-wrapper"
          onClick={() => {
            this.toggleFontVariant("small-caps");
          }}
        >
          SC
        </div>
        <div 
          className="rdw-option-wrapper"
          onClick={() => {
            this.toggleFontVariant("normal");
          }}
        >
          not SC
        </div>
      </div>      
    );
  }
}

export default FontVariant;